import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_CLIENT',
  title: 'Mes clients peuvent-ils voir avec qui je travaille ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'La confidentialité est le partenariat de confiance qu’Attestation Légale a avec ses clients. Aucun de vos clients ne peut voir avec qui vous avez été ou avec qui vous êtes en contrat.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Cette confidentialité n’existe pas dans le cadre d’une opération. Le client de votre client peut accéder à votre dossier.'
  }]
};
